import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {InputState} from 'app/entities/enums';
import {AppModalService} from 'app/services/appModal.service';
import {plainToInstance} from 'class-transformer';
import {File} from 'app/entities/file.entity';
import {HelperService} from 'app/services/helper.service';
import {ChatService} from 'app/services/chat.service';
import {MessageContent} from '../../../../../../chat-sdk/src/entities/messages/messageContent';
import {Message} from '../../../../../../chat-sdk/src/entities/messages/message';

@Component({
  selector: 'app-chat-input-field',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatInputFieldComponent implements OnInit {
  chatService: ChatService;
  modalService: AppModalService;
  messageSendCallback: (content: Partial<MessageContent>) => void;
  onReady: (chatInput: ChatInputFieldComponent) => void;

  get replyToMessage(): Message {
    return this._replyToMessage;
  }

  set replyToMessage(value: Message) {
    this._replyToMessage = value;
  }

  get editedMessage(): Message {
    return this._editedMessage;
  }

  set editedMessage(value: Message) {
    this._editedMessage = value;

    if (this._editedMessage === null) {
      this.form.reset();
    } else {
      this.form.setValue({
        text: this._editedMessage.content.text,
        attachments: this._editedMessage.content.attachments,
      });
    }

  }

  form = new FormGroup({
    text: new FormControl(''),
    attachments: new FormControl([])
  });

  private _editedMessage: Message = null;
  private _replyToMessage: Message = null;

  constructor(
    chatService: ChatService,
    modalService: AppModalService
  ) {
    this.chatService = chatService;
    this.modalService = modalService;
  }

  ngOnInit() {
    this.form.disable();
    this.onReady(this);
  }

  async send() {

    // console.log(this.form.value);

    if (this.messageSendCallback) {

      const content: Partial<MessageContent> = {};

      // @todo chat validation

      // if (this.form.value.text) {
        content.text = this.form.value.text;
      // }

      if (this.form.value.attachments !== null) {
        content.attachments = this.form.value.attachments.map(item => item.nativeFile ? item.nativeFile : item);
      }

      // if (this.replyToMessage) {/
      content.replyToMessage = this.replyToMessage;
      // }

      console.log(content);

      if (content.text || content.attachments?.length) {
        if (this.editedMessage) {
          this.editedMessage.edit(content);
        } else {
          this.messageSendCallback(content);
        }
        this.reset();
      }
    }
  }

  getFileState(): InputState {
    if (this.form.controls.attachments.touched) {
      return this.form.controls.attachments.valid ? null : 'error';
    }

    return null;
  }

  async openMediaModal() {
    if (this.form.disabled) {
      return;
    }
    await this.modalService.openMediaUploadModal({
      maxFiles: 10
    }, (files) => {
      if (files) {
        this.form.controls.attachments.setValue([...(this.form.value.attachments?.length ? this.form.value.attachments : []), ...files.map(item => File.fromWebApiFile(item))]);
      }
    });
  }

  reset() {
    this.form.reset();
    this.cancelEdit();
  }

  cancelEdit() {
    this.editedMessage = null;
    this.replyToMessage = null;
  }

  cancelReply() {
    this.replyToMessage = null;
  }

  onKeyDown(ev: KeyboardEvent) {
    if (ev.code === 'Enter' && !ev.shiftKey) {
      this.send();
      return false;
    }
    return true;
  }
}
